import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { RegionService } from '@app/core/services';

@Pipe({
  name: 'ingoFormatNumber'
})
export class IngoFormatNumberPipe implements PipeTransform {

  private locales = { SE: 'sv', DK: 'da' };

  constructor(
    private decimalPipe: DecimalPipe,
    private regionService: RegionService
  ) {}

  transform(value: number, digitsInfo: string = '1.2-2'): string {

    const countryCode = this.regionService.getCountryCode();
    return this.decimalPipe.transform(value, digitsInfo, this.locales[countryCode]);
  }
}

